<ew-mat-dialog-custom ngClass="overflow-hidden">
  <main class="mx-10 mt-8">
    <!-- Form section - shown when not in success state -->
    <div *ngIf="!success">
      <h1>{{ 'registerEmail:title' | translate }}</h1>
      <form [formGroup]="form">
        <div class="flex flex-col mt-4 overflow-hidden">
          <mat-form-field>
            <mat-label>E-mail</mat-label>
            <input matInput type="email" formControlName="email" placeholder="Digite o e-mail" required />

            <mat-error *ngIf="form.controls['email'].errors">
              <span *ngIf="form.controls['email'].errors['required']">
                <strong>
                  {{ 'registerEmail:emailRequired' | translate }}
                </strong>
              </span>

              <span *ngIf="form.controls['email'].errors['email']">
                <strong>
                  {{ 'registerEmail:emailInvalid' | translate }}
                </strong>
              </span>
            </mat-error>
          </mat-form-field>
        </div>

        <hr class="my-4" />

        <div class="flex justify-end gap-4">
          <button
            mat-stroked-button
            class="rounded-lg xs:w-full w-20"
            color="secondary"
            (click)="cancel()">
            {{ 'registerEmail:cancel' | translate }}
          </button>

          <button
            mat-flat-button
            class="rounded-lg xs:w-full w-40"
            color="primary"
            [disabled]="!form.valid || loading"
            (click)="save()">
            {{ 'registerEmail:save' | translate }}
          </button>
        </div>
      </form>
    </div>

    <!-- Success message section -->
    <div
      class="text-center grid gap-4 max-w-2xl"
      *ngIf="!loading && success">
      <div class="mb-5 text-5xl font-bold">
        {{ 'registerEmail:successTitle' | translate }}
      </div>
      <div>
        {{ 'registerEmail:successMessage' | translate }}
      </div>
      <div class="flex justify-center mt-4">
        <button
          mat-flat-button
          class="rounded-lg w-40"
          color="primary"
          (click)="closeDialog()">
          {{ 'registerEmail:close' | translate }}
        </button>
      </div>
    </div>
  </main>
</ew-mat-dialog-custom>